import * as React from "react"
import useRouter from "@digits-shared/hooks/useRouter"
import routes from "src/frontend/routes"

export function useGoToLogin() {
  const { history } = useRouter()
  return React.useCallback(() => {
    history.replace(routes.login.generate())
  }, [history])
}
